/**
 * @file 权益列表组件
 */
import React from 'react';
import styles from './BenefitList.module.less';
import type {BenefitInfo} from '@/services/commerce/membership/interface';
import Icon from '@/components/common/Icon';
import Tooltip from '@/components/common/Tooltip';

interface BenefitListProps {
    benefits: BenefitInfo[];
}

export const BenefitList: React.FC<BenefitListProps> = ({benefits}) => {
    return (
        <div className={styles.benefitList}>
            {benefits.map((benefit) => (
                <div key={benefit.benefitType}>
                    <div className={styles.title}>{benefit.benefitType}</div>
                    <div className={styles.list}>
                        {benefit.list.map((item) => (
                            <div key={item.benefitName} className={styles.benefit}>
                                <Icon name="AijhBasicDuihao" size={16} />
                                <span>{item.benefitName}</span>
                                {item.desc && (
                                    <Tooltip
                                        title={item.desc}
                                        placement="top"
                                        classNames={{
                                            root: styles.benefitTips,
                                        }}
                                        styles={{root: {pointerEvents: 'none'}}}
                                    >
                                        <Icon
                                            name="AijBasicTishi2"
                                            size={12}
                                            className={styles.benefitTipsIcon}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
